import { DemoApiMock } from '../types'
import { getDemoData, matchRestRequest } from '../utils'

export const mockGetPositions: DemoApiMock = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/current_company_04bfc888',
      'POST'
    ) ||
    matchRestRequest(
      request,
      '/company/graphql_dispatch/position_roster_cc1c2964',
      'POST'
    ) ||
    matchRestRequest(
      request,
      '/company/graphql_dispatch/position_tutorials_fd510ac5',
      'POST'
    ),
  getResponse: async () => {
    const demoData = getDemoData()
    return {
      data: {
        company: {
          positions: demoData.positions,
        },
      },
    }
  },
}
